// Enabler E7-C (ADO-2274), D-1: the ordering entry a catalogue read is for.
//
// Search and browse show only the range of the entry the store selected, and the server keeps no
// session state, so every catalogue read names it: `entry=<activeEntryKey>`, the
// `${kind}:${depotCode}` key of `useSessionStore.activeEntryKey`. The catalogue routes answer 400
// without it and 403 for an entry the caller does not hold; the favourites routes take it as
// optional, because the web hydrates favourites at boot, before an entry exists.

/** The query parameter every catalogue read carries. */
export const ENTRY_PARAM = 'entry';

/** `path` with the entry appended to its query, whether or not it already has one. */
export function withEntry(path: string, entry: string): string {
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}${ENTRY_PARAM}=${encodeURIComponent(entry)}`;
}
